import { createContext, useContext } from "react";
import { TreatmentComponentState } from "@/services/backend/rlt/treatments/lib/treatment-component-state";

export const useTreatmentComponentState = () =>
  useContext(TreatmentComponentStateContext);

interface TreatmentComponentStateContextInterface {
  state: TreatmentComponentState;
  setState: (state: TreatmentComponentState) => void;
  disabled: boolean;
}

export const TreatmentComponentStateContext =
  createContext<TreatmentComponentStateContextInterface>({
    state: {
      columns: [],
      availableColumns: [],
    },
    setState: () => null,
    disabled: false,
  });
